module.exports = __webpack_public_path__ + "img/achivement_innovation_fair_barisal_2023.ed81efaf.jpg";